import { getServicesHost } from 'common/utils/context'

// routes
const languagePathParam = '/:languageCode?'
const ticketsPath = '/tickets'
const ticketsSearchPath = `${languagePathParam}${ticketsPath}/:origin/:destination`
const ticketsOffsiteRedirectPath = '/redirects/transit'

const servicesHost = getServicesHost()

// Versioned API endpoints
const ticketableSchedulesEndpoint = `${servicesHost}/api/1.5/json/ticketableschedules`
const flightSchedulesEndpoint = `${servicesHost}/api/1.5/json/flightschedules`
const flightDetailsEndpoint = `${servicesHost}/api/1.5/json/flightdetails`
const flightPollingEndpoint = `${servicesHost}/api/1.5/json/flightpolling`
const currenciesEndpoint = `${servicesHost}/api/1.5/json/currencies`
const schedulesConfigEndpoint = `${servicesHost}/api/1.5/json/SchedulesConfiguration`
const autocompleteEndpoint = `${servicesHost}/api/1.5/json/Autocomplete`
const geocodeEndpoint = `${servicesHost}/api/1.5/json/geocode`

// API endpoints
const backendLogEventEndpoint = `${servicesHost}/api/json/BackendLogCheckoutEvent`
const backendLogExitEndpoint = `${servicesHost}/api/json/LogExit`
const backendLogSearchEndpoint = `${servicesHost}/api/json/LogUserLook`
const backendSignMapURL = `${servicesHost}/api/json/SignMapUrl`

export {
  ticketsPath,
  ticketsSearchPath,
  ticketsOffsiteRedirectPath,
  ticketableSchedulesEndpoint,
  currenciesEndpoint,
  schedulesConfigEndpoint,
  flightSchedulesEndpoint,
  flightDetailsEndpoint,
  flightPollingEndpoint,
  backendLogEventEndpoint,
  backendLogExitEndpoint,
  backendLogSearchEndpoint,
  autocompleteEndpoint,
  geocodeEndpoint,
  backendSignMapURL,
}
